module.exports = __webpack_public_path__ + "img/ISpearman64_ua.69b82638.webp";